<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="scopeName" :label="$t('labelTitle.Range')" v-if="$store.state.type === 3 || $store.state.type === 2" show-overflow-tooltip />
        <el-table-column :label="$t('public.trigger')" show-overflow-tooltip prop="name">
            <template #default="{row}">
                <span>{{ row.name }}</span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('integration.number_of_used')" show-overflow-tooltip prop="useNumber" />
        <el-table-column :label="$t('public.table_create_time')" show-overflow-tooltip prop="createTime">
            <template #default="{ row }">{{ $timetransition(row.createTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('public.table_operation')" prop="operate" width="120px" align="center">
            <template #default="{ row }">
                <AlarmSwitch
                    class="uk-margin-small-right"
                    :sceneId="row.sceneId"
                    :related="1"
                    :alarm-switch="row.alarmSwitch"
                    :trigger-ids="[row.id]"
                    :getList="() => (row.alarmSwitch = !row.alarmSwitch)"
                ></AlarmSwitch>
                <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.details')" v-has="['uptRange']" @click="detailFn(row)"></el-button>
                <el-button @click="delsMonitor(row)" :title="$t('buttonTitle.Delete')" icon="el-icon-delete" type="text" size="small" v-has="['delRange']" :disabled="row.useNumber !== 0"></el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import AlarmSwitch from '@/components/AlarmSwitch/AlarmSwitch'
export default {
  props: ['loading', 'tableData'],
  components: {
    AlarmSwitch
  },
  data () {
    return {
      tableHeight: 'calc(100% - 60px)'
    }
  },
  methods: {
    handleSelectionChange (arg) {
      this.$emit('choozeTableFn', arg)
    },
    detailFn (row) {
      this.$emit('detailFn', row)
    },
    delsMonitor (row) {
      this.$emit('delFn', row)
    }
  }
}
</script>

<style></style>
